/* tslint:disable */
/* eslint-disable */
/**
 * CMA API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateCMAResponseDto
 */
export interface CreateCMAResponseDto {
    /**
     * 
     * @type {string}
     * @memberof CreateCMAResponseDto
     */
    id: string;
}

/**
 * Check if a given object implements the CreateCMAResponseDto interface.
 */
export function instanceOfCreateCMAResponseDto(value: object): value is CreateCMAResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function CreateCMAResponseDtoFromJSON(json: any): CreateCMAResponseDto {
    return CreateCMAResponseDtoFromJSONTyped(json, false);
}

export function CreateCMAResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCMAResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function CreateCMAResponseDtoToJSON(json: any): CreateCMAResponseDto {
    return CreateCMAResponseDtoToJSONTyped(json, false);
}

export function CreateCMAResponseDtoToJSONTyped(value?: CreateCMAResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
    };
}

